import React from 'react';
import { X, Info, ShieldCheck, AlertCircle } from 'lucide-react';

function GroupDetailModal({ group, onClose, setSelectedItem, handleSellOne }) {
  if (!group) return null;

  return (
    <div className="fixed inset-0 bg-slate-950/80 backdrop-blur-md z-[80] flex items-center justify-center p-6" onClick={onClose}>
      <div className="bg-slate-900 rounded-[50px] w-full max-w-4xl max-h-[85vh] overflow-hidden flex flex-col shadow-2xl border border-white/5" onClick={e => e.stopPropagation()}>
        <div className="p-8 sm:p-10 border-b border-white/5 flex justify-between items-center bg-white/5">
          <div className="flex-1 min-w-0 pr-4">
            <h3 className="text-2xl font-black text-white truncate drop-shadow-md">{group.product_name}</h3>
            <p className="text-slate-500 text-xs font-bold mt-1">Jami: {group.all?.length || 0} dona ({group.all?.filter(i => i.is_verified).length} tasi tekshirilgan)</p>
          </div>
          <button onClick={onClose} className="p-4 bg-white/5 rounded-2xl text-slate-400 hover:text-rose-500 shadow-sm transition shrink-0"><X size={32}/></button>
        </div>
        <div className="flex-1 overflow-y-auto p-8 sm:p-12 space-y-4 bg-slate-900 custom-scrollbar">
          {group.all.map((item, i) => (
            <div key={i} className={`flex flex-col sm:flex-row justify-between items-center p-8 rounded-[35px] hover:shadow-2xl transition-all border ${item.is_verified ? 'bg-emerald-500/5 border-emerald-500/20 hover:bg-emerald-500/10' : 'bg-white/5 border-transparent hover:border-blue-500/20 hover:bg-white/10'} group`}>
              <div className="flex-1 pr-0 sm:pr-8 w-full sm:w-auto">
                 <div className="flex items-center gap-5 mb-4">
                    <span className={`w-10 h-10 ${item.is_verified ? 'bg-emerald-600' : 'bg-blue-600'} text-white rounded-xl flex items-center justify-center shadow-lg text-sm font-black`}>#{i+1}</span>
                    <div className="flex items-center gap-2">
                       <span className={`text-[10px] uppercase tracking-[0.3em] ${item.is_verified ? 'text-emerald-500' : 'text-blue-500'} font-black`}>
                          {item.is_verified ? 'Tekshirilgan Markirovka' : 'Markirovka Tafsiloti'}
                       </span>
                       {item.is_verified && <ShieldCheck size={14} className="text-emerald-500" />}
                    </div>
                 </div>
                 <div className={`text-xs font-mono break-all p-5 rounded-2xl border leading-relaxed shadow-inner ${item.is_verified ? 'bg-black/50 text-emerald-400 border-emerald-500/10' : 'bg-black/30 text-slate-300 border-white/5'}`}>
                    {item.marking_code}
                 </div>
              </div>
              <div className="flex gap-4 mt-6 sm:mt-0 w-full sm:w-auto">
                 <button
                  onClick={() => {
                    setSelectedItem(item);
                    onClose();
                  }}
                  className="p-5 bg-white/5 text-slate-400 rounded-2xl hover:text-blue-400 hover:bg-blue-400/10 transition shadow-sm flex-1 sm:flex-none flex justify-center"
                 >
                    <Info size={28}/>
                 </button>
                 <button
                  onClick={() => handleSellOne(item)}
                  className="bg-slate-800 text-white px-10 py-5 rounded-[22px] font-black text-sm hover:bg-emerald-600 transition shadow-xl uppercase tracking-widest flex-1 sm:flex-none border border-white/5"
                 >
                   SOTISH
                 </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GroupDetailModal;
